import React from "react";
import {
  MdRotateLeft,
  MdRotateRight,
  MdZoomIn,
  MdZoomOut,
} from "react-icons/md";
import styles from "./DocumentViewer.module.scss";

const ImageToolbar = ({
  fileName,
  showFileName = true,
  onRotateLeft,
  onRotateRight,
  onZoomOut,
  onZoomIn,
  zoomOutDisabled = false,
  zoomInDisabled = false,
}) => {
  return (
    <div
      className={`d-flex align-items-center flex-shrink-0 gap-2 ${styles["image-toolbar"]} ${
        showFileName ? "justify-content-between" : "justify-content-end"
      }`}
      role="toolbar"
      aria-label="Image actions">
      {showFileName && (
        <span className={styles["image-toolbar-filename"]} title={fileName}>
          {fileName}
        </span>
      )}
      <div className={styles["image-toolbar-actions"]}>
        <button
          type="button"
          className={styles["image-toolbar-btn"]}
          onClick={onRotateLeft}
          title="Rotate left"
          aria-label="Rotate left">
          <MdRotateLeft size={18} aria-hidden />
        </button>
        <button
          type="button"
          className={styles["image-toolbar-btn"]}
          onClick={onRotateRight}
          title="Rotate right"
          aria-label="Rotate right">
          <MdRotateRight size={18} aria-hidden />
        </button>
        <button
          type="button"
          className={styles["image-toolbar-btn"]}
          onClick={onZoomOut}
          disabled={zoomOutDisabled}
          title="Zoom out"
          aria-label="Zoom out">
          <MdZoomOut size={18} aria-hidden />
        </button>
        <button
          type="button"
          className={styles["image-toolbar-btn"]}
          onClick={onZoomIn}
          disabled={zoomInDisabled}
          title="Zoom in"
          aria-label="Zoom in">
          <MdZoomIn size={18} aria-hidden />
        </button>
      </div>
    </div>
  );
};

export default ImageToolbar;
